import type { PhoneNumber } from 'antd-phone-input';

/**
 * Converte o valor do campo de telefone - código do país, DDD e número
 * separados - na forma **E.164**: `+5511987654321`, sem espaço nem parêntese.
 *
 * É a forma que se guarda. A máscara bonita (`+55 (11) 98765-4321`) é da tela;
 * gateway de pagamento e API de mensagem querem esta.
 *
 * Devolve `null` quando só sobrou o código do país. Esse é o estado de campo
 * **vazio**: a máscara mantém o `+55` mesmo depois de apagar tudo, e gravar
 * `"+55"` como telefone de alguém seria gravar lixo.
 *
 * Mora fora do componente para poder ser testada sem montar Ant Design inteiro.
 */
export function paraE164(valor: PhoneNumber | null | undefined): string | null {
  if (!valor?.countryCode) return null;
  const numero = `${valor.areaCode ?? ''}${valor.phoneNumber ?? ''}`.replace(/\D/g, '');
  return numero ? `+${valor.countryCode}${numero}` : null;
}
